var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger",on:{"click":_vm.alertConfimacao}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }